import { useSyncExternalStore } from "react";

const HEROUI_THEME_STORAGE_KEY = "heroui-theme";
const PREFERS_DARK_MEDIA = "(prefers-color-scheme: dark)";

const subscribe = (callback: () => void) => {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
};

const getSnapshot = (): string => {
  const fromAttribute = document.documentElement.getAttribute("data-theme");
  if (fromAttribute) return fromAttribute;

  const stored = localStorage.getItem(HEROUI_THEME_STORAGE_KEY);
  if (stored && stored !== "system") return stored;

  return window.matchMedia?.(PREFERS_DARK_MEDIA).matches ? "dark" : "light";
};

const getServerSnapshot = (): string => "light";

export const useAppTheme = (): string =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
